import { useEffect, useState } from "react";
import { Sparkles, Save, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { FullSpinner } from "@/components/States";
import { toast } from "sonner";

const QUESTIONS = {
  Personality: ["Introvert", "Ambivert", "Extrovert"],
  Communication: ["Direct", "Diplomatic", "Reserved"],
  Career: ["Career-first", "Balanced", "Family-first"],
  Family: ["Very close-knit", "Moderately involved", "Independent"],
  Finance: ["Saver", "Balanced", "Spender"],
  Lifestyle: ["Homebody", "Balanced", "Very social/outgoing"],
  Children: ["Want soon", "Want later", "Undecided", "Prefer not"],
  Location: ["Stay in home city", "Open within India", "Open globally"],
  Values: ["Traditional", "Moderate", "Progressive"],
  Travel: ["Love travel", "Occasional", "Prefer home"],
  "Social life": ["Large circle", "Few close friends", "Private"],
  "Future goals": ["Settle & stable", "Growth & ambition", "Adventure & experiences"],
};

export default function CompatibilityLab() {
  const [answers, setAnswers] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/compatibility-lab").then(({ data }) => setAnswers(data.assessment?.answers || {})); }, []);
  if (!answers) return <FullSpinner />;
  const set = (cat, val) => setAnswers((a) => ({ ...a, [cat]: val }));
  const done = Object.keys(answers).length;

  const save = async () => { setBusy(true); try { await api.post("/compatibility-lab", { answers }); toast.success("Assessment saved"); } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); } };

  return (
    <div className="max-w-3xl mx-auto space-y-5" data-testid="compatibility-lab-page">
      <div>
        <h1 className="font-serif text-3xl font-bold text-[#58111A] flex items-center gap-2"><Sparkles className="w-6 h-6 text-[#C59B27]" /> Compatibility Lab</h1>
        <p className="text-sm text-[#605255]">Answer honestly. We'll reveal strong alignment and topics to discuss with your matches. This is informational and never predicts marriage success.</p>
        <div className="mt-2 text-sm font-medium text-[#781826]">{done} / {Object.keys(QUESTIONS).length} answered</div>
      </div>
      <div className="space-y-3">
        {Object.entries(QUESTIONS).map(([cat, opts]) => (
          <div key={cat} className="mj-card p-4" data-testid={`lab-${cat.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="font-serif text-lg font-semibold text-[#261A1C] mb-2">{cat}</div>
            <div className="flex flex-wrap gap-2">
              {opts.map((o) => (
                <button key={o} onClick={() => set(cat, o)} className={`text-sm px-3.5 py-1.5 rounded-full border ${answers[cat] === o ? "bg-[#781826] text-white border-[#781826]" : "bg-white border-[#E8DFD1] text-[#605255] hover:border-[#C59B27]"}`}>{o}</button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={busy} data-testid="save-lab" className="btn-primary w-full">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4" /> Save Assessment</>}</button>
    </div>
  );
}
